var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{class:['scroll-box',{'scroll-box-horizontal':_vm.isHorizontal}],attrs:{"native":false,"tag":_vm.tag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }